import React from 'react';
import DefaultQuestionnaireModal from './DefaultQuestionnaireModal';

interface RemoveDefaultModalProps {
  isOpen: boolean;
  questionnaireName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const RemoveDefaultModal: React.FC<RemoveDefaultModalProps> = ({
  isOpen,
  questionnaireName,
  onConfirm,
  onCancel,
}) => {
  return (
    <DefaultQuestionnaireModal
      isOpen={isOpen}
      position="top"
      onClose={onCancel}
      footer={
        <div className="dq-modal-footer">
          <button className="dq-btn dq-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="dq-btn dq-btn--danger" onClick={onConfirm}>
            Remove Default
          </button>
        </div>
      }
    >
      <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem', color: '#181C32' }}>Remove Default Questionnaire</h3>
      <p>
        Going forward, new job listings will not have <br />{questionnaireName} applied
        automatically. This update will not affect existing job postings.
      </p>
    </DefaultQuestionnaireModal>
  );
};

export default RemoveDefaultModal;
